/**
 * Mandatory cart fee v3 — adds variant 57968219062575 when cart has other items.
 * Updated: 2026-05-22
 */
(function () {
  var DEFAULT_VARIANT_ID = '57968219062575';
  var PROPERTY_KEY = '_mandatory_fee';
  var syncing = false;
  var syncTimer = null;

  function getConfig() {
    var cfg = window.MandatoryCartFeeConfig || {};
    return {
      enabled: cfg.enabled !== false && cfg.enabled !== 'false',
      variantId: String(cfg.variantId != null ? cfg.variantId : DEFAULT_VARIANT_ID),
    };
  }

  function isMandatoryVariantId(variantId) {
    return String(variantId) === getConfig().variantId;
  }

  function isMandatoryItem(item) {
    if (!item) return false;
    if (isMandatoryVariantId(item.variant_id)) return true;
    if (item.properties && item.properties[PROPERTY_KEY]) return true;
    return false;
  }

  function partitionCartItems(items) {
    var mandatory = [];
    var other = [];
    (items || []).forEach(function (item) {
      if (isMandatoryItem(item)) mandatory.push(item);
      else other.push(item);
    });
    return { mandatory: mandatory, other: other };
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      return res.json();
    });
  }

  function formatFeeMoney(cents) {
    var amount = (parseInt(cents, 10) || 0) / 100;
    if (typeof formatter !== 'undefined') return formatter.format(amount);
    return amount.toFixed(2);
  }

  function renderFeeLine(cart, attempt) {
    if (!getConfig().enabled || typeof jQuery === 'undefined') return;
    attempt = attempt || 0;

    jQuery('.mandatory-cart-fee-item').remove();
    if (!cart || !cart.items || !cart.items.length) return;

    var feeItem = null;
    cart.items.forEach(function (item) {
      if (isMandatoryItem(item)) feeItem = item;
    });
    if (!feeItem) return;

    var $bind = jQuery('.js__ajax-products-bind');
    if (!$bind.length && attempt < 20) {
      setTimeout(function () {
        renderFeeLine(cart, attempt + 1);
      }, 150);
      return;
    }

    var productName = String(
      feeItem.product_title || feeItem.title || 'Processing Fee'
    ).split(' with ')[0];
    var price = formatFeeMoney(
      feeItem.final_line_price || feeItem.line_price || feeItem.price
    );
    var lineKey = feeItem.key || String(feeItem.variant_id || feeItem.id);
    var variantId = feeItem.variant_id || feeItem.id;
    var imageURL =
      feeItem.featured_image && feeItem.featured_image.url
        ? feeItem.featured_image.url
        : '';
    var imageHtml = imageURL
      ? '<a href="javascript:void(0)"><img alt="" src="' + imageURL + '"></a>'
      : '';

    var miniLine =
      '<li class="flex-wrap js__cart-table-item-row mandatory-cart-fee-item" data-line-key="' +
      lineKey +
      '" data-variant-id="' +
      variantId +
      '"><div class="image-section">' +
      imageHtml +
      '</div><div class="content"><div class="title-section"><h5><span class="mandatory-fee-label">' +
      productName +
      '</span></h5><span class="mandatory-fee-locked">Required</span></div><div class="flex-space-between"><div class="cart-quantity-outer mandatory-fee-qty"><span>Qty 1</span></div><div class="cart-price-outer"><span class="price">' +
      price +
      '</span></div></div></div></li>';

    $bind.append(miniLine);

    if (jQuery('.cart-list')[0]) {
      jQuery('.cart-list').append(
        '<div class="cart-list__items cart-table-body js__cart-table-item-row mandatory-cart-fee-item flex" data-line-key="' +
          lineKey +
          '" data-variant-id="' +
          variantId +
          '"><div class="cart-list__items__columns"><div class="image-section">' +
          imageHtml +
          '</div><div class="content"><h5><span class="mandatory-fee-label">' +
          productName +
          '</span></h5><span class="mandatory-fee-locked">Required</span></div></div><div class="cart-list__items__columns"><span class="price">' +
          price +
          '</span></div><div class="cart-list__items__columns"><div class="mandatory-fee-qty">Qty 1</div></div><div class="cart-list__items__columns recharge"></div><div class="cart-list__items__columns total-price"><span class="price">' +
          price +
          '</span></div></div>'
      );
    }
  }

  function applyCartChanges(cart) {
    var parts = partitionCartItems(cart.items);

    if (parts.other.length === 0) {
      if (!parts.mandatory.length) return Promise.resolve(cart);
      var clearUpdates = {};
      parts.mandatory.forEach(function (item) {
        clearUpdates[item.key || String(item.variant_id)] = 0;
      });
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: clearUpdates }),
      })
        .then(function (r) {
          return r.json();
        })
        .catch(function () {
          return fetchCart();
        });
    }

    if (
      parts.mandatory.length === 1 &&
      parts.mandatory[0].quantity === 1
    ) {
      return Promise.resolve(cart);
    }

    var chain = Promise.resolve(cart);

    if (parts.mandatory.length) {
      var dedupe = {};
      parts.mandatory.forEach(function (item) {
        dedupe[item.key || String(item.variant_id)] = 0;
      });
      chain = chain
        .then(function () {
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ updates: dedupe }),
          });
        })
        .then(function () {
          return fetchCart();
        });
    }

    return chain.then(function (latest) {
      var state = partitionCartItems((latest && latest.items) || []);
      if (state.other.length && !state.mandatory.length) {
        var props = {};
        props[PROPERTY_KEY] = 'true';
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: Number(getConfig().variantId),
            quantity: 1,
            properties: props,
          }),
        })
          .then(function (r) {
            if (!r.ok) {
              return r.json().then(function (err) {
                console.error('[MandatoryCartFee] add failed', err);
                throw err;
              });
            }
            return fetchCart();
          });
      }
      return latest && latest.items ? latest : fetchCart();
    });
  }

  function needsSync(cart) {
    var parts = partitionCartItems(cart.items);
    if (!parts.other.length) return parts.mandatory.length > 0;
    if (!parts.mandatory.length) return true;
    if (parts.mandatory.length > 1) return true;
    if (parts.mandatory[0].quantity !== 1) return true;
    return false;
  }

  function publishCart(cart) {
    if (!cart) return;
    if (typeof CartJS !== 'undefined') CartJS.cart = cart;
    renderFeeLine(cart);
    if (typeof reloadAjaxCartItemUsingCartAjaxObject === 'function') {
      reloadAjaxCartItemUsingCartAjaxObject(cart);
    } else if (typeof quickCartTotal === 'function') {
      quickCartTotal(cart);
    }
  }

  function syncMandatoryFee() {
    if (!getConfig().enabled) return Promise.resolve(null);
    if (window.MandatoryCartFee._suppressSync) return Promise.resolve(null);
    if (syncing) return syncMandatoryFee._pending || Promise.resolve(null);

    syncing = true;
    window.MandatoryCartFee._suppressSync = true;

    syncMandatoryFee._pending = fetchCart()
      .then(function (cart) {
        if (!needsSync(cart)) return cart;
        return applyCartChanges(cart);
      })
      .then(function (cart) {
        publishCart(cart);
        return cart;
      })
      .catch(function (err) {
        console.warn('[MandatoryCartFee] sync error', err);
        return fetchCart().then(function (cart) {
          publishCart(cart);
          return cart;
        });
      })
      .finally(function () {
        syncing = false;
        window.MandatoryCartFee._suppressSync = false;
        syncMandatoryFee._pending = null;
      });

    return syncMandatoryFee._pending;
  }

  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncMandatoryFee, delay == null ? 100 : delay);
  }

  function patchFetch() {
    if (window.__mandatoryCartFeeFetchPatched) return;
    window.__mandatoryCartFeeFetchPatched = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url =
        typeof input === 'string' ? input : input && input.url ? input.url : '';
      var isCart =
        /\/cart\/(add|update|change)(\.js)?(\?|$)/i.test(String(url));
      return nativeFetch.apply(this, arguments).then(function (response) {
        if (
          isCart &&
          response.ok &&
          getConfig().enabled &&
          !window.MandatoryCartFee._suppressSync
        ) {
          scheduleSync(250);
        }
        return response;
      });
    };
  }

  function bindEvents() {
    document.addEventListener('ajaxProduct:added', function () {
      scheduleSync(300);
    });

    if (typeof jQuery !== 'undefined') {
      jQuery(document).on('click', '.cart-link, .js__cart-expand', function () {
        scheduleSync(50);
      });
    }

    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest(
          '.remove, .js__cart-item-remove, [data-cart-remove-variant]'
        );
        if (!btn) return;
        var vid =
          btn.getAttribute('data-variant-id') ||
          btn.getAttribute('data-cart-remove-variant');
        if (vid && isMandatoryVariantId(vid)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          scheduleSync(50);
        }
      },
      true
    );

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) scheduleSync(100);
    });

    setInterval(function () {
      if (syncing || window.MandatoryCartFee._suppressSync) return;
      fetchCart().then(function (cart) {
        if (partitionCartItems(cart.items).other.length && needsSync(cart)) {
          scheduleSync(50);
        } else {
          renderFeeLine(cart);
        }
      });
    }, 5000);
  }

  window.MandatoryCartFee = {
    PROPERTY_KEY: PROPERTY_KEY,
    _suppressSync: false,
    isMandatoryItem: isMandatoryItem,
    isMandatoryVariantId: isMandatoryVariantId,
    renderFeeLine: renderFeeLine,
    sync: syncMandatoryFee,
    schedule: scheduleSync,
  };

  if (!getConfig().enabled) return;

  patchFetch();
  bindEvents();
  scheduleSync(0);
  document.addEventListener('DOMContentLoaded', function () {
    scheduleSync(150);
  });
  window.addEventListener('load', function () {
    scheduleSync(300);
  });
  window.addEventListener('pageshow', function () {
    scheduleSync(100);
  });
})();
